// Generated by packages/providers/scripts/generate-provider-registry.mjs. Do not edit manually.
import { orderAuthProviders } from "../provider-order.js";
import { anthropicProvider } from "./anthropic.js";
import { cloudflareProvider } from "./cloudflare.js";
import { openaiProvider } from "./openai.js";
import { poeProvider } from "./poe.js";

export * from "./anthropic.js";
export * from "./cloudflare.js";
export * from "./openai.js";
export * from "./poe.js";

export const allAuthProviders = orderAuthProviders([
  anthropicProvider,
  cloudflareProvider,
  openaiProvider,
  poeProvider
]);
